import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient } from "aws-amplify/api";
import { updateSubscriptionPrice as updateSubscriptionPriceMutation } from "@/graphql/mutations";

const client = generateClient();

export const updateSubscriptionPriceState = create<State<boolean>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const updateSubscriptionPriceIsloading = () =>
  updateSubscriptionPriceState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const updateSubscriptionPriceIsError = (error: Error) =>
  updateSubscriptionPriceState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const updateSubscriptionPriceIsSuccess = (listInvoices: boolean) =>
  updateSubscriptionPriceState.setState(() => ({
    data: listInvoices,
    isLoading: false,
    error: null,
  }));

export const resetUpdateSubscriptionPriceState = () =>
  updateSubscriptionPriceState.setState(() =>
    updateSubscriptionPriceState.getInitialState(),
  );

export type UpdateSubscriptionPriceParams = {
  priceId: string;
  quantity?: number;
};

export const updateSubscriptionPrice = async (
  params: UpdateSubscriptionPriceParams,
) => {
  updateSubscriptionPriceIsloading();

  try {
    const { data } = await client.graphql({
      query: updateSubscriptionPriceMutation,
      variables: {
        priceId: params.priceId,
        quantity: params.quantity,
      },
    });

    updateSubscriptionPriceIsSuccess(data.updateSubscriptionPrice as boolean);
  } catch (e) {
    const errorMessage =
      e instanceof Error
        ? e.message
        : "failed to mutate update subscription price";
    updateSubscriptionPriceIsError(Error(errorMessage));
  }
};
